import React from "react";
import { IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  DrawerContent,
  DrawerStyled,
  ExpandedContent,
  CollapsedContent,
} from "./drawer.styles";

const LeftDrawer = ({
  expandedContent,
  collapsedContent,
  label,
  expanded,
  setExpanded,
}) => {
  const drawerWidth = expanded ? "1000px" : "250px";

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <DrawerStyled
      variant="persistent"
      anchor="left"
      open={true}
      drawerWidth={drawerWidth}
      expanded={expanded}
      ModalProps={{ disablePortal: true }}
    >
      <DrawerContent>
        <div className="drawer-header">
          <Typography variant="body4">{label}</Typography>
          <IconButton className="button" onClick={handleToggle}>
            {expanded ? (
              <ChevronLeftIcon sx={{ color: "#080425" }} />
            ) : (
              <ChevronRightIcon sx={{ color: "#080425" }} />
            )}
          </IconButton>
        </div>
        {expanded ? (
          <ExpandedContent>{expandedContent}</ExpandedContent>
        ) : (
          <CollapsedContent onClick={() => setExpanded(true)}>
            {collapsedContent}
          </CollapsedContent>
        )}
      </DrawerContent>
    </DrawerStyled>
  );
};

export default LeftDrawer;
